import { render, staticRenderFns } from "./Genius.vue?vue&type=template&id=2204311a&scoped=true&"
import script from "./Genius.vue?vue&type=script&lang=ts&"
export * from "./Genius.vue?vue&type=script&lang=ts&"
import style0 from "./Genius.vue?vue&type=style&index=0&id=2204311a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204311a",
  null
  
)

export default component.exports